import {useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import Form from "./Form";
import {UsePost} from "../../hooks/http";
import {useNavigate} from "react-router-dom";
import {UseMessage} from "../../hooks/UseMessage";

const Create = () => {
    const navigate = useNavigate()
    const [errors, setErrors] = useState()
    const [isLoading, setIsLoading] = useState(false)


    const handleCreate = (PostData) => {
        setIsLoading(true)
        UsePost(
            '/plans/upsert/',
            {data: PostData}
        ).then((response) => {
            if (response.code >= 200 && response.code <= 299) {
                navigate(`/plans/${response.id}`)
                UseMessage('success', 'Plan has been successfully created')
            } else {
                setErrors(response.errors)
            }
            setIsLoading(false)
        })
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form isReady={!isLoading} errors={errors} onSubmit={handleCreate}/>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Create